import { render, staticRenderFns } from "./BoutiqueDetail.vue?vue&type=template&id=246d1180&scoped=true&"
import script from "./BoutiqueDetail.vue?vue&type=script&lang=js&"
export * from "./BoutiqueDetail.vue?vue&type=script&lang=js&"
import style0 from "./BoutiqueDetail.vue?vue&type=style&index=0&id=246d1180&lang=scss&scoped=true&"
import style1 from "./BoutiqueDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246d1180",
  null
  
)

export default component.exports